import React from 'react';
import { FieldArray } from 'formik';

import { Button } from 'react-bootstrap';
import { CommonHash, LandingComponentButton } from 'app/types';
import { BUTTONSIZEOPTIONS, BUTTONSTYLEOPTIONS } from 'common/constants';

import Text from 'common/components/Text/Text';
import styles from './LandingForm.module.scss';

interface LandingComponentButtonFormProps {
  name: string;
  landing_component: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  limit: number;
}

const LandingComponentButtonForm = ({
  name,
  landing_component,
  handleChange,
  limit,
}: LandingComponentButtonFormProps): React.ReactElement => {
  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div>
          {landing_component.landing_component_buttons &&
          landing_component.landing_component_buttons.length ? (
            landing_component.landing_component_buttons.map(
              (landing_cmp_button: LandingComponentButton, index: number) => (
                <div key={index}>
                  <Text size={22}> Button {index + 1} </Text>
                  <div className="d-flex gap-3 align-items-center mt-2">
                    <div className={styles.group}>
                      <label htmlFor={`${name}[${index}].text`}>Button Text</label>
                      <input
                        name={`${name}[${index}].text`}
                        placeholder="Button text"
                        onChange={handleChange}
                        value={landing_cmp_button.text || ''}
                      />
                    </div>
                    <div className={styles.group}>
                      <label htmlFor={`${name}[${index}].link`}>Button Link</label>
                      <input
                        name={`${name}[${index}].link`}
                        placeholder="Button Link"
                        onChange={handleChange}
                        value={landing_cmp_button.link || ''}
                      />
                    </div>
                    <div className={styles.group}>
                      <label htmlFor={`${name}[${index}].style`}>Button Style</label>
                      <select
                        name={`${name}[${index}].style`}
                        onChange={handleChange}
                        value={
                          landing_component.landing_component_buttons[index]['style']
                            ? landing_component.landing_component_buttons[index]['style']
                            : 'primary'
                        }
                      >
                        {BUTTONSTYLEOPTIONS.map((opt, e) => {
                          return (
                            <option key={e} value={opt}>
                              {opt}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className={styles.group}>
                      <label htmlFor={`${name}[${index}].size`}>Button Size</label>
                      <select
                        name={`${name}[${index}].size`}
                        onChange={handleChange}
                        value={
                          landing_component.landing_component_buttons[index]['size']
                            ? landing_component.landing_component_buttons[index]['size']
                            : 'default'
                        }
                      >
                        {BUTTONSIZEOPTIONS.map((opt, e) => {
                          return (
                            <option key={e} value={opt}>
                              {opt}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <Button
                      type="button"
                      variant="danger"
                      className={styles.deleteButton}
                      onClick={() => {
                        arrayHelpers.remove(index);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                  {index === landing_component.landing_component_buttons.length - 1 &&
                    landing_component.landing_component_buttons.length <= limit - 1 && (
                      <Button
                        type="button"
                        className="mt-3"
                        variant="success"
                        onClick={() =>
                          arrayHelpers.push({
                            text: '',
                            link: '',
                            style: 'primary',
                          })
                        }
                      >
                        + Button
                      </Button>
                    )}
                </div>
              )
            )
          ) : (
            <Button
              type="button"
              className="mt-3"
              variant="success"
              onClick={() =>
                arrayHelpers.push({
                  text: '',
                  link: '',
                  style: 'primary',
                })
              }
            >
              Add a Button
            </Button>
          )}
        </div>
      )}
    />
  );
};

export default LandingComponentButtonForm;
